module.exports = __webpack_public_path__ + "img/photography.d49fd318.png";